import React from 'react';
import { StaticImage } from 'gatsby-plugin-image';
import styled from 'styled-components';
import { Link } from 'gatsby';
import { HeroGrid } from '../styles/Grids';

export const HeroBkImg = styled.div`
  //The image will take up the whole grid and be in the background
  grid-column: 1 / -1;
  grid-row: 1 / -1;
  z-index: 1;
`;

const HeroCTA = styled.div`
  //The link to "Offerings" or whatever else we want as the attention-getter
  grid-column-end: 3;
  grid-row-end: 3;
  z-index: 99;
  background-color: white;
  width: 30vmin;
  height: 30vmin;
  border-radius: 50%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  text-align: center;
  margin-top: 3vmin;
  font-size: 3vmin;
  box-shadow: 0 1px 3px rgb(0 0 0 / 12%), 0 1px 2px rgb(0 0 0 / 24%);
`;

const BrowseButton = styled.button`
  background-color: var(--light-accent);
  border: var(--dark-accent);
  color: var(--ivory);
  text-align: center;
  display: inline-block;
  border-radius: 10vmin;
  margin-top: 1vmin;
  a {
    color: var(--ivory);
  }
  padding: 3vmin 6vmin;
`;

export default function Hero() {
  return (
    <HeroGrid>
      <HeroBkImg>
        <StaticImage
          src="../assets/images/logo-original.jpg"
          alt="Site Logo"
          placeholder="blurred"
          layout="fullWidth"
        />
      </HeroBkImg>
      <HeroCTA>
        INTENTIONAL JEWELRY
        <BrowseButton>
          <Link to="/browse">Browse</Link>
        </BrowseButton>
      </HeroCTA>
    </HeroGrid>
  );
}
